import {Pipe, PipeTransform} from "@angular/core";
import {NumberUtils} from "projects/fello-common/src/lib";

@Pipe({
  name: "formatPhone",
  standalone: true
})
export class FormatPhonePipe implements PipeTransform {
  transform(phoneNumber: string | undefined): string {
    return NumberUtils.formatPhone(phoneNumber);
  }
}
